import FilterChip from "./FilterChip";

export default function ActiveFilterBar({ chips, onRemove, onClearAll }) {
  if (!chips || chips.length === 0) return null;
  return (
    <div className="flex items-center gap-2 flex-wrap md:flex-nowrap overflow-x-auto md:overflow-visible">
      <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#8A8A8A] shrink-0">
        FILTERS:
      </span>
      <div className="flex items-center gap-2 flex-wrap md:flex-nowrap md:overflow-x-auto no-scrollbar">
        {chips.map((c, i) => (
          <FilterChip
            key={`${c.dimension}-${c.value}-${i}`}
            label={c.label}
            value={c.displayValue}
            onRemove={() => onRemove(c.dimension, c.value)}
          />
        ))}
      </div>
      <button
        type="button"
        onClick={onClearAll}
        className="ml-auto shrink-0 font-sans text-[12px] uppercase tracking-[0.04em] font-semibold text-white hover:text-[#FF9F1C] underline underline-offset-4 decoration-white/40 hover:decoration-[#FF9F1C]"
      >
        Clear all
      </button>
    </div>
  );
}
